import React, { useState } from "react";
import { FormFeedback, Input, FormGroup } from "reactstrap";
import { checkValidations } from '../../../utils/checkValidations';
import { validationMessage } from '../../../utils/validation';



const EmailBox = React.forwardRef(({ name, placeholder, min = 1, max = 249, value = '', edit = true, isRequired = true, handleVal, isIcon = false, icon = false, isLocked, className = '', label = '',
    id = 'id', labelLink = false, handleKeypress, _ref }, ref) => {

    const [email, setEmail] = useState({ value: value, isValid: false });

    const getEmailAddress = (name, value) => {
        const val = value.replace(/\s+/g, ' ').trim();
        checkValidations(name, val, min, max) ? setEmail({ value: value, isValid: false }) : setEmail({ value: value, isValid: true })
        handleVal(value);
    }

    return (
        <>
            {/* <label htmlFor="feEmail">{Name}</label>
            {isRequired && <span style={{ 'color': '#ff0000' }}>  *</span>} */}
            <FormGroup className={`input-wrapper ${className}`}>
                <label className="label d-flex" htmlFor={id}>
                    {label}
                </label>
                <Input
                    id={id}
                    ref={ref}
                    innerRef={_ref}
                    type="email"
                    placeholder={placeholder}
                    name="email"
                    value={email.value}
                    disabled={!edit}
                    maxLength={max + 1}
                    required
                    autoComplete="off"
                    invalid={Boolean(email.isValid && !isIcon) || Boolean(email.value && email.value.length > max)}
                    onKeyDown={(e) => e.keyCode === 13 && handleKeypress(e)}
                    onChange={($event) => { getEmailAddress('email', typeof $event === 'string' || typeof $event === 'undefined' ? $event : $event.target.value) }}
                    style={{ borderColor: email.value.length ? edit && email.isValid ? '#c4183c' : "" : "" }}
                />
                {(isIcon) && <i className="material-icons" style={{ cursor: "pointer", zIndex: 1 }} onClick={() => { isLocked() }}>{icon ? ('lock_open') : 'lock'}</i>}

                {(!email.value.length) ? <FormFeedback className={email.isValid && !email.value.length ? 'customerror' : ''}>{validationMessage['emailReq']}</FormFeedback> : ''}
                {email.value && email.value.length ? <FormFeedback className={email.isValid && email.value.length ? 'customerror' : ''}> {validationMessage['emailInvalid']}</FormFeedback> : ''}
                {(email.value && email.value.length > max) ? <FormFeedback className={email.value && email.value.length > max ? 'customerror' : ''}>{validationMessage['numberMaxInvalid'](max)}</FormFeedback> : ''}
            </FormGroup>
        </>
    );

});
export default EmailBox;